class PopupModal extends HTMLElement {
  static observedAttributes = ["open"];

  constructor() {
    super();
    this.style.visibility = 'hidden';

    this.open = this.getAttribute('open') == "true";
    this.preventEditor = this.getAttribute('prevent-editor') == "true";
    this.allowOverflow = this.getAttribute('allow-overflow') == "true";

    this.elSection = this.closest('.shopify-section') ? this.closest('.shopify-section') : document;
    this.elToggles = this.elSection.querySelectorAll(`[data-popup-toggle][aria-controls="${this.id}"]`);

    this.elToggles.forEach(el => {
      el.addEventListener('click', () => {
        this.dispatchEvent(new CustomEvent('toggle', { detail: {
          open: el.hasAttribute('data-close') ? false : !this.open,
          el: el
        }}));
        this.setAttribute('open', !this.open);
      })
    })

    if(!this.preventEditor) {
      if(this.hasAttribute('data-shopify-editor-block')) {
        document.addEventListener('shopify:block:select', ({ detail }) => {
          const blockData = JSON.parse(this.getAttribute('data-shopify-editor-block'));
          const { domId } = blockData;
          domId == detail.blockId ? this.setAttribute('open', true) : this.close();
        });
      } else {
        document.addEventListener('shopify:section:select', ({ detail }) => {
          let sectionId = `shopify-section-${detail.sectionId}`;
          this.elSection && this.elSection.id == sectionId ? this.setAttribute('open', true) : this.close();
        });
      }
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if(name == 'open') {
      if(newValue == "true") {
        this.open = true;
        this.setVisibility(this.open);
        setTimeout(() => {
          this.classList.add('open');
        }, 100);
        this.focus({ preventScroll: true });
        this.addEventListener('keydown', this.trapFocus);
        !this.allowOverflow && document.body.classList.add('overflow-hidden');
      } else {
        this.open = false;
        this.classList.remove('open');
        document.activeElement.blur();
        setTimeout(() => {
          this.setVisibility(this.open);
          this.removeEventListener('keydown', this.trapFocus);
        }, 300);
        document.body.classList.remove('overflow-hidden');
      }
    }
  }

  setVisibility(visible) {
    this.style.visibility = visible ? 'visible' : 'hidden';
    this.ariaHidden = visible ? false : true;
    this.tabIndex = visible ? 0 : -1;
  }

  close() {
    this.setAttribute('open', false);
  }

  trapFocus(ev) {
    const focusableElements = 'button, a, [href], input, select, textarea, [tabindex="0"]';
	
    const elModal = ev.currentTarget;
    const elFocusElements = elModal.querySelectorAll(focusableElements);
    const elFirstFocus = elFocusElements[0];
    const elLastFocus = elFocusElements[elFocusElements.length - 1];
    const elCurrentFocus = document.activeElement;
    
    const isNextFocus = ev.key == 'Tab' || ev.key == 'ArrowRight';
    const isPrevFocus = ev.shiftKey && ev.key == 'ArrowLeft';
    
    if(isNextFocus && elCurrentFocus == elLastFocus) {
      ev.preventDefault();
      elFirstFocus.focus({ preventScroll: true });
    } else if(isPrevFocus && elCurrentFocus == elFirstFocus) {
      ev.preventDefault();
      elLastFocus.focus({ preventScroll: true });
	  }
  }
}

customElements.define('popup-modal', PopupModal);